import COM from './BaseComponent'

export default COM
